//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  isEmpty,
} from "@/utils/validate";
export default {
  data() {
    return {
      Elite: true,
      isLogin: false, // 是否登录
      logoImg: require('../../static/picture/header-logo.png'),
      codeIconImg: require('../../static/picture/code_icon.png'),
      codeImg: require('../../static/picture/code.png'),
      tableData: [
        { accountType: '商标查询', youth: true, professional: true, elite: true, supreme: true },
        { accountType: '批量查询', youth: '有限试用', professional: '500次/年', elite: '1000次/年', supreme: true },
        { accountType: '国际商标查询', youth: '有限试用', professional: true, elite: true, supreme: true},
        { accountType: '图形查询', youth: '有限试用', professional: '2500次/年', elite: '5000次/年', supreme: true},
        { accountType: '商品分类', youth: true, professional: true, elite: true, supreme: true },
        { accountType: '商标对比', youth: true, professional: true, elite: true, supreme: true },
        { accountType: '商标公告', youth: '1000次/年', professional: true, elite: true, supreme: true },
        { accountType: '裁定文书', youth: true, professional: true, elite: true, supreme: true },
        { accountType: '商标监控', youth: '有限试用', professional: '1200个/年', elite: '1800个/年', supreme: true },
        { accountType: '商标分析', youth: '有限试用', professional: '4000次/年', elite: '8000次/年', supreme: true },
        { accountType: '业务线索/品牌风险', youth: '有限试用', professional: '3万条/年', elite: '6万条/年', supreme: true},
        { accountType: '专项查询', youth: '有限试用', professional: true, elite: true, supreme: true },
        { accountType: 'AI近似分析', youth: '有限试用', professional: '600次/年', elite: '2000次/年', supreme: true},
      ],
     /* tableDataTwo:[
        { accountType: '商标批量查新', youth: false, professional: true, elite: true, supreme: true },
        { accountType: '国际商标查询', youth: false, professional: true, elite: true, supreme: true },
      ],*/
      isOpen: false
    }
  },
  mounted() {
    if (!isEmpty(localStorage.getItem(this.$route.query.token))) {
      localStorage.setItem("uc_token", this.$route.query.token);
      setTimeout(() => {
        location.href = "/";
      }, 0);
      return;
    }
    let token = localStorage.getItem("uc_token");
    if (!isEmpty(token) && token != "undefined" && token != "null") {
      this.getUserInfo();
    } else {
      this.isLogin = false;
      localStorage.setItem("uc_token", "");
    }
  },
  methods: {
   /* arraySpanMethod({ row, column, rowIndex, columnIndex }){
      if (row.accountType === 'no') {
          return {
            rowspan: [1, 2,3,4,5,6]
          }
      }
    },*/
    tableRowClassName({row, rowIndex}){
      // 基数行返回 'odd-row'，偶数行返回 'even-row'
      return rowIndex % 2 === 0 ? 'odd-row' : 'even-row';
    },
    getUserInfo() {
      this.$axios
        .post("/api/auth/getUserInfo", { isGoLogin: true })
        .then(res => {
          this.$store.commit("setUser", res.data.data);
          this.isLogin = res.data.code === 0;
        });
    },
    isString(value){
      return typeof value === "string";
    },
    openTool(){

    }
  }
}
